import { Model } from '@vuex-orm/core'
import firestore from '@/firebase'
import _ from 'lodash'
import axios from 'axios'

function isInternshipActive(item) {
  var startdate = item.startDate ? new Date(item.startDate.seconds * 1000) : ''
  var enddate = item.endDate ? new Date(item.endDate.seconds * 1000) : ''

  if (
    (startdate !== '' &&
      enddate !== '' &&
      new Date() >= startdate &&
      new Date() <= enddate) ||
    (startdate !== '' && new Date() >= startdate && enddate === '')
  ) {
    return true
  } else {
    return false
  }
}

function getInternshipUsers(email) {
  return firestore
    .collection('internships')
    .where('tutorEmail', '==', email)
    .get()
    .then(snapshot => {
      return snapshot.docs.map(doc => ({
        ...doc.data(),
        id: doc.id
      }))
    })
    .catch(err => {
      this.$store.dispatch(
        'showErrorSnackbar',
        err.message || 'Something went wrong'
      )
    })
}

async function getUsers(token, role, email, hospital, specialty) {
  let filter = {}

  if (role === 'trainee-tutor') {
    filter = {
      mainTutorEmail: email,
      specialty: specialty
    }
  } else if (role === 'coordinator') {
    filter = {
      hospital: hospital,
      specialty: specialty
    }
  } else if (role === 'internship-responsible') {
    const internshipUsers = await getInternshipUsers(email)
    const userIds = _.uniqBy(
      internshipUsers
        .filter(user => isInternshipActive(user))
        .map(user => user.userId) || []
    )
    if (!userIds.length) {
      return []
    }

    filter = {
      userId: userIds
    }
  }

  if (!_.isEmpty(filter)) {
    const userQuery = axios.get(`/users?${objectToQueryString(filter)}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })

    return userQuery.then(users =>
      users?.data ? users.data.map(u => ({ ...u, relationShip: role })) : []
    )
  } else {
    return []
  }
}

function objectToQueryString(obj) {
  var str = []
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
    }
  return str.join('&')
}

export class CoordinatedUsers extends Model {
  static entity = 'coordinatedUsers'
  static primaryKey = 'id,relationShip'

  static fields() {
    return {
      id: this.string(),
      firstName: this.string(),
      lastName: this.string(),
      specialty: this.string(),
      hospital: this.string(),
      license: this.string(),
      relationShip: this.string(),
      email: this.string(),
      residencyStart: this.string()
    }
  }

  static async fetch(token, roles, email, hospital, specialty) {
    let users = []

    await Promise.all(
      roles.map(role => getUsers(token, role, email, hospital, specialty))
    ).then(result => {
      users = result.reduce((acc, cur) => [...acc, ...cur], [])
    })

    this.create({ data: users })
  }
}
